import Media from './../mediaDetect.js'; //Детектор медиа

let Search = {
    Header: {
        openSearch: function(btn, input){
            $('.menu__search').addClass("active");
            input.addClass("active");
            btn.addClass("active");
        },
        closeSearch: function(btn, input){
            $('.menu__search').removeClass("active");
            input.removeClass("active");
            btn.removeClass("active");
        }
    },
    openTips: function(tips, input){
        tips.addClass("open");
        input.addClass("tips-open");
    },
    closeTips: function(tips, input) {
        tips.removeClass("open");
        input.removeClass("tips-open");
    },
    ajaxResult: function(currValue, tips) {
        $.ajax({
            url: '/api/search.completion/?q=' + currValue + '&how=r',
            dataType: 'json'
        })
        .done(function(response) {
            tips.empty();

            if (response.status == 'ERROR') {
                tips.text(response.description);
            } else {
                $.each(response.items, function(nn, item) {
                    tips.append(
                        $('<a>')
                            .attr('href', item.href)
                            .addClass('search__tips-text')
                            .html(item.label)
                    );
                });
            }
        })
        .fail(function() {
            tips.empty();
        });
    }
}

$(document).ready(function ($) {

    $(".page").on("click",function(e){
        if (!($(e.target).closest('[data-search]').length)){
            var btnSearch = $('[data-btn-submit-search]'),
                inputSearch = $('[data-input-search]'),
                tipsSearch = $('[data-tips-search]');

            Search.Header.closeSearch(btnSearch, inputSearch);
            Search.closeTips(tipsSearch, inputSearch);
        };
    })

    $('[data-btn-submit-search]').on('click', function (e) {
        var _this = $(this),
            containerSearch = _this.closest('[data-search]'),
            inputSearch = containerSearch.find('[data-input-search]'),
            tipsSearch = containerSearch.find('[data-tips-search]'),
            type = containerSearch.data('search');

        if((type == 'header') && (!Media.detect().isMobile)) {

            if (!inputSearch.hasClass("active")){
                e.preventDefault();
                Search.Header.openSearch(_this, inputSearch);
            } else {
                Search.Header.closeSearch(_this, inputSearch);
                Search.closeTips(tipsSearch, inputSearch);
            };
        }
    });  

    var timerSearchKeyUp = false;
    var searchLastValue = '';
    var searchCurrValue = '';

    $('[data-input-search]').on('input', function(){

        var _this = $(this),
            container = _this.closest('[data-search]'),
            tips = container.find('[data-tips-search]');

        if (timerSearchKeyUp) {
            clearTimeout(timerSearchKeyUp);
        }
        timerSearchKeyUp = setTimeout(() => {

            tips.empty().text('Поиск...');

            searchCurrValue = _this.val();
            if (searchLastValue == searchCurrValue) {
                return;
            }
            searchLastValue = searchCurrValue;


            if(container.find('[data-clear-form-search]').length){
                var btnClearForm = $('[data-clear-form-search]');

                if(searchCurrValue != ''){
                    btnClearForm.addClass('show');
                }else{
                    btnClearForm.removeClass('show');
                }
            }

            Search.ajaxResult(searchCurrValue, tips);

            Search.openTips(tips, _this);

        }, 1000);        
    })

    $('[data-input-search]').on('focus', function(){
        var _this = $(this),
            container = _this.closest('[data-search]'),
            tips = container.find('[data-tips-search]');

        if(_this.val() != ''){
            Search.openTips(tips, _this);
        }
    });

    $('body').on('click', '[data-clear-form-search]', function(){
        var _this = $(this),
            container = _this.closest('[data-search]'),
            input = container.find('[data-input-search]'),
            tips = container.find('[data-tips-search]');

        input.val('').focus();
        Search.closeTips(tips, input);
        _this.removeClass('show');
    });
    
});



// WEBPACK FOOTER //
// ./components/search.js